module.exports = __webpack_public_path__ + "img/love-icon.4b7c5896.svg";